import { c as _c } from "react/compiler-runtime";
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import ProgressiveImage from '@/ui/segments/landing/components/progressive-image/progressive-image';
import { cn } from '@/utils/css-class';
type HeroProps = {
  videoURL: string;
  posterURL: string;
  posterWidth: number;
  posterHeight: number;
  title: string;
};
export default function HeroGallery(t0) {
  const $ = _c(27);
  const {
    videoURL,
    posterURL,
    posterWidth,
    posterHeight,
    title
  } = t0;
  const [videoReady, setVideoReady] = React.useState(false);
  const videoRef = React.useRef(null);
  let t1;
  let t2;
  if ($[0] !== videoURL) {
    t1 = () => {
      if (videoRef.current && videoURL) {
        videoRef.current.load();
        videoRef.current.play().catch(_temp);
      }
    };
    t2 = [videoURL];
    $[0] = videoURL;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  React.useEffect(t1, t2);
  let t3;
  if ($[3] !== posterHeight || $[4] !== posterURL || $[5] !== posterWidth) {
    t3 = posterURL && posterWidth && posterHeight && <ProgressiveImage src={posterURL} width={posterWidth} height={posterHeight} alt="Hero image" />;
    $[3] = posterHeight;
    $[4] = posterURL;
    $[5] = posterWidth;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = videoReady ? "block" : "hidden";
  let t5;
  if ($[7] !== t4) {
    t5 = cn("h-screen w-screen object-cover", t4);
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = videoURL ?? "";
  let t10;
  let t7;
  let t8;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setVideoReady(true);
    t8 = () => setVideoReady(true);
    t9 = () => {
      setVideoReady(true);
    };
    t10 = <track kind="captions" />;
    $[9] = t10;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t10 = $[9];
    t7 = $[10];
    t8 = $[11];
    t9 = $[12];
  }
  let t11;
  if ($[13] !== t5 || $[14] !== t6) {
    t11 = <video ref={videoRef} className={t5} loop={true} muted={true} autoPlay={true} playsInline={true} preload="auto" disablePictureInPicture={true} src={t6} onCanPlay={t7} onLoadedData={t8} onLoadedMetadata={t9}>{t10}</video>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t3) {
    t12 = <div className="absolute top-0 left-0 z-0 h-screen w-screen">{t3}{t11}</div>;
    $[16] = t11;
    $[17] = t3;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== title) {
    t13 = <h1 className="my-0! text-[16vmin]! text-white md:text-[10vmin]!">{title}</h1>;
    $[19] = title;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <h2 className="font-gabarito text-2xl! leading-normal! font-bold hyphens-auto text-white md:text-4xl!">Discover image and video assets created by our team. Made with our tools and technologies.</h2>;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t13) {
    t15 = <div className="relative top-0 left-0 z-10 flex flex-col items-center text-center">{t13}{t14}</div>;
    $[22] = t13;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t12 || $[25] !== t15) {
    t16 = <div className="relative flex h-screen w-screen items-center justify-center px-10 md:px-[14vw]">{t12}{t15}</div>;
    $[24] = t12;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  return t16;
}
function _temp() {}